const actions = {
    ACCOUNT_CREATE_REQUEST: 'ACCOUNT_CREATE_REQUEST',
    ACCOUNT_CREATE_SUCCESS: 'ACCOUNT_CREATE_SUCCESS',
    ACCOUNT_CREATE_ERROR: 'ACCOUNT_CREATE_ERROR',
    ACCOUNT_READ_ALL_REQUEST: 'ACCOUNT_READ_ALL_REQUEST',
    ACCOUNT_READ_ALL_SUCCESS: 'ACCOUNT_READ_ALL_SUCCESS',
    ACCOUNT_READ_ALL_ERROR: 'ACCOUNT_READ_ALL_ERROR',
    ACCOUNT_READ_REQUEST: 'ACCOUNT_READ_REQUEST',
    ACCOUNT_READ_SUCCESS: 'ACCOUNT_READ_SUCCESS',
    ACCOUNT_READ_ERROR: 'ACCOUNT_READ_ERROR',
    ACCOUNT_UPDATE_REQUEST: 'ACCOUNT_UPDATE_REQUEST',
    ACCOUNT_UPDATE_SUCCESS: 'ACCOUNT_UPDATE_SUCCESS',
    ACCOUNT_UPDATE_ERROR: 'ACCOUNT_UPDATE_ERROR',
    ACCOUNT_ARCHIVE_REQUEST: 'ACCOUNT_ARCHIVE_REQUEST',
    ACCOUNT_ARCHIVE_SUCCESS: 'ACCOUNT_ARCHIVE_SUCCESS',
    ACCOUNT_ARCHIVE_ERROR: 'ACCOUNT_ARCHIVE_ERROR',
    ACCOUNT_DELETE_REQUEST: 'ACCOUNT_DELETE_REQUEST',
    ACCOUNT_DELETE_SUCCESS: 'ACCOUNT_DELETE_SUCCESS',
    ACCOUNT_DELETE_ERROR: 'ACCOUNT_DELETE_ERROR',
    ACCOUNT_IMPORT_REQUEST: 'ACCOUNT_IMPORT_REQUEST',
    ACCOUNT_IMPORT_SUCCESS: 'ACCOUNT_IMPORT_SUCCESS',
    ACCOUNT_IMPORT_ERROR: 'ACCOUNT_IMPORT_ERROR',
    ACCOUNT_SET_ACCOUNT: 'ACCOUNT_SET_ACCOUNT',
    ACCOUNT_SET_SYSTEM_TYPE: 'SET_SYSTEM_TYPE',
    ACCOUNT_SET_TYPE: 'SET_TYPE',
    ACCOUNT_SET_CURRENCY_CODE: 'SET_CURRENCY_CODE',
    ACCOUNT_SET_PARENT_ID: 'ACCOUNT_SET_PARENT_ID',
    ACCOUNT_MERGE_REQUEST: 'ACCOUNT_MERGE_REQUEST',
    ACCOUNT_MERGE_SUCCESS: 'ACCOUNT_MERGE_SUCCESS',
    ACCOUNT_MERGE_ERROR: 'ACCOUNT_MERGE_ERROR',
    ACCOUNT_SET_TABLE_IDS: 'ACCOUNT_SET_TABLE_IDS',
    ACCOUNT_RESET: 'ACCOUNT_RESET',
    ACCOUNT_SET_SYSTEM_TYPES_BY_INVENTORY_SYSTEM: 'ACCOUNT_SET_SYSTEM_TYPES_BY_INVENTORY_SYSTEM',

    create: request => ({
        type: actions.ACCOUNT_CREATE_REQUEST,
        request,
    }),
    readAll: request => ({
        type: actions.ACCOUNT_READ_ALL_REQUEST,
        request,
    }),
    read: id => ({
        type: actions.ACCOUNT_READ_REQUEST,
        id,
    }),
    update: (id, request) => ({
        type: actions.ACCOUNT_UPDATE_REQUEST,
        id,
        request,
    }),
    archive: (id, request) => ({
        type: actions.ACCOUNT_ARCHIVE_REQUEST,
        id,
        request,
    }),
    delete: id => ({
        type: actions.ACCOUNT_DELETE_REQUEST,
        id,
    }),
    import: request => ({
        type: actions.ACCOUNT_IMPORT_REQUEST,
        request,
    }),
    set: (request, reset = false) => ({
        type: actions.ACCOUNT_SET_ACCOUNT,
        request,
        reset,
    }),
    setSystemType: systemType => ({
        type: actions.ACCOUNT_SET_SYSTEM_TYPE,
        systemType,
    }),
    setType: typeVal => ({
        type: actions.ACCOUNT_SET_TYPE,
        typeVal,
    }),
    setCurrencyCode: currencyCode => ({
        type: actions.ACCOUNT_SET_CURRENCY_CODE,
        currencyCode,
    }),
    setParentId: parentId => ({
        type: actions.ACCOUNT_SET_PARENT_ID,
        parentId,
    }),
    mergeAccounts: request => ({
        type: actions.ACCOUNT_MERGE_REQUEST,
        request, // { account_ids: [1,2,3], merge_id: [1]}
    }),
    setAccountTableIds: ids => ({
        type: actions.ACCOUNT_SET_TABLE_IDS,
        ids,
    }),
    reset: () => ({
        type: actions.ACCOUNT_RESET,
    }),
};
export default actions;
